import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// We previously registered a service worker for PWA / offline support, but it
// caused stale-cache problems on mobile after every redeploy (Google OAuth
// silently failing, /legal pages serving cached 404s). We no longer register
// a SW. The kill-switch SW at /service-worker.js takes care of unregistering
// any SW left over from older builds the next time a user lands on the site.
//
// Belt-and-braces: also actively unregister any existing SW from the page
// itself. If we detect that the current page is controlled by an old SW,
// reload once to bypass the stale cached HTML/JS — otherwise the user keeps
// running the old code we're trying to replace.
if ("serviceWorker" in navigator) {
  const wasControlledByOldSW = !!navigator.serviceWorker.controller;

  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => Promise.all(registrations.map((r) => r.unregister())))
    .then(() => {
      if (typeof caches !== "undefined") {
        return caches.keys().then((names) => Promise.all(names.map((n) => caches.delete(n))));
      }
      return null;
    })
    .then(() => {
      // If the current document was being served via an old service worker,
      // the HTML + JS in memory are likely stale. Do a one-time hard reload
      // (we set a sessionStorage flag so we never reload-loop).
      if (wasControlledByOldSW && !sessionStorage.getItem("__ge_sw_cleanup_done")) {
        sessionStorage.setItem("__ge_sw_cleanup_done", "1");
        window.location.reload();
      }
    })
    .catch(() => { /* non-fatal */ });
}
